// extracted by mini-css-extract-plugin
export default {"dropzone":"AttachmentAddZone_dropzone__H5wht","wrapper":"AttachmentAddZone_wrapper__dnijA"};